








































































































// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import SideBar from '@/components/SideBar/index.vue';
import ImageViewer from '@/components/ImageViewer/index.vue';
import GoogleMap from '@/components/GoogleMap/index.vue';

import Addition from '@/views/Home/Addition/index.vue';
import DevStack from '@/views/Home/DevStack/index.vue';
import Story from '@/views/Home/Story/index.vue';
import ProjectDisplay from '@/views/Home/ProjectDisplay/index.vue';
import Contact from '@/views/Home/Contact/index.vue';

import { ImageSrc } from '@/store/types.ts';
import * as backgroundMe from '../../assets/Background_Me.jpg';
import * as backgroundInterests from '../../assets/Background_Interests3.jpg';
// https://survivejs.com/webpack/loading/images/
// https://medium.com/javascript-in-plain-english/how-to-display-images-from-local-assets-images-folder-when-working-with-react-feb6c5dba526

export default {
  name: 'Home',
  components: {
    // SideBar,
    ImageViewer,
    Addition,
    DevStack,
    Story,
    ProjectDisplay,
    Contact,
    GoogleMap
  },
  data: () => {
    return {
      chosenId: '1',
      name: 'Hyunsik Byun'
      // drawer: true
    };
  },
  computed: {
    firstMenu: {
      get(): string {
        return (this as any).$store.state.drawer;
      },
      set(value: boolean) {
        (this as any).$store.dispatch('setDrawer', value);
      }
    },
    images() {
      return (this as any).$store.state.images;
    },
    chosenImage(): ImageSrc {
      return (this as any).images.find(
        (image: ImageSrc) => image.id === (this as any).chosenId
      );
    }
  },
  mounted() {
    // const src = require(`@/assets/Hyunsik_2.jpg`);
    (this as any).setBackground('section_1', `url(${backgroundMe})`);
    (this as any).setBackground('section_3', `url(${backgroundInterests})`);
    // (this as any).setBackground('section_32', `url(${backgroundInterests})`);
  },
  methods: {
    setChosenId(id: string) {
      (this as any).chosenId = id;
    },
    setNext() {
      const intId = parseInt((this as any).chosenId);
      const newId = ((intId + 1) % 3).toString();
      this.setChosenId(newId);
    },
    setPrevious() {
      const intId = parseInt((this as any).chosenId);
      const newId = ((intId + 2) % 3).toString();
      this.setChosenId(newId);
    },
    scrollDown(elementId: string, navBarId: '') {
      const y = (document.getElementById(
        elementId
      ) as HTMLElement).getBoundingClientRect().top;
      const navBar = document.getElementById(navBarId);
      if (document.documentElement.clientWidth >= 768 && navBar) {
        const navBarY = navBar.getBoundingClientRect().height;
        window.scrollBy({
          top: y - navBarY,
          behavior: 'smooth'
        });
      } else {
        window.scrollBy({
          top: y,
          behavior: 'smooth'
        });
      }
    },
    setBackground(elementId: string, src: string) {
      const element = document.getElementById(elementId) as HTMLElement;
      element.style.backgroundImage = src;
      element.style.backgroundSize = 'auto 120vh';
      element.style.height = '100vh';
    }
  }
};
